import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import TutorialStore from '../../stores/TutorialStore';
import HeaderBanner from '../../components/common/HeaderBanner';
import TutorialLink from '../../components/tutorial/TutorialLink';
import TutorialGame from '../../components/tutorial/TutorialGame';
import SearchSection from '../../components/tutorial/SearchSection';
import MetaTags from '../../components/common/MetaTags';

@connectToStores
export default class GameTutorialView extends React.Component {
    constructor(props) {
        super(props);
        if (!props.tutorialStore) return;
        this.state = {
            searchResult: null
        }
    }
    static propTypes = {
        tutorialStore: PropTypes.object //eslint-disable-line
    };
    static getStores() {
        return [TutorialStore];
    }

    static getPropsFromStores() {
        return {
            tutorialStore: TutorialStore.getState()
        };
    }

    search = (input) => {
        const val = input.target.value.trim().toLowerCase();
        const data = this.props.tutorialStore.gameTutorial.utTutorialAccordion.accordion;
        if (!val) {
            this.setState({
                searchResult: null
            })
        } else {
            const searchResult = [];
            data.forEach((element, i) => {
                const result = element.question.filter((item) => item.name.toLowerCase().indexOf(val) >= 0);
                if (result.length > 0) {
                    searchResult.push(Object.assign({...element}, {question: result}));
                }
            });
            this.setState({searchResult});
        }
    }

    render() {
        const pageData = this.props.tutorialStore.gameTutorial || {};
        const {_title, utTutorialAccordion = {}} = pageData;
        const {description, headerImage, title, accordion = []} = utTutorialAccordion;
        const data = this.state.searchResult || accordion;
        return (
            <div className="game-tutorial-view">
                <MetaTags meta={{title: _title}} />
                <HeaderBanner title={title} image={headerImage} content={description}>
                    <TutorialLink data={data} />
                </HeaderBanner>
                <SearchSection onSearch={this.search} />
                <div className="container-fluid content-container">
                    <div className="row">
                        {data.length > 0 &&
                            data.map((group) => {
                                return <TutorialGame data={group} key={group.id} />
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}
